import type { OrgId, SiteId } from "../ids";

export interface Site {
  readonly id: SiteId;
  readonly orgId: OrgId;
  readonly name: string;
  readonly address: string | null;
  readonly postcode: string | null;
  readonly latitude: number | null;
  readonly longitude: number | null;
  readonly gpsRadiusMetres: number;
  readonly clientContactName: string | null;
  readonly clientContactEmail: string | null;
  readonly notes: string | null;
  readonly deletedAt: string | null;
  readonly createdAt: string;
}

export interface CreateSiteInput {
  readonly name: string;
  readonly address: string | null;
  readonly postcode: string | null;
  readonly latitude: number | null;
  readonly longitude: number | null;
  readonly gpsRadiusMetres: number;
  readonly clientContactName: string | null;
  readonly clientContactEmail: string | null;
  readonly notes: string | null;
}

export interface UpdateSiteInput {
  readonly name: string;
  readonly address: string | null;
  readonly postcode: string | null;
  readonly latitude: number | null;
  readonly longitude: number | null;
  readonly gpsRadiusMetres: number;
  readonly clientContactName: string | null;
  readonly clientContactEmail: string | null;
  readonly notes: string | null;
}

export const GPS_RADIUS_DEFAULT = 400;

export const GPS_RADIUS_PRESETS = [
  { value: 200, label: "200m (Tight)" },
  { value: 400, label: "400m (Standard)" },
  { value: 1000, label: "1000m (Wide)" },
] as const;

const VALID_GPS_RADII: ReadonlySet<number> = new Set(GPS_RADIUS_PRESETS.map((p) => p.value));

export function isValidGpsRadius(value: number): boolean {
  return VALID_GPS_RADII.has(value);
}
